// GET /{locale}/search/suggest?q={query}&resources[type]=product&section_id={section_id}

export const getSearchResults = (callback = null, keyword = '', sectionId = 'predictive-search') => {
  fetch(`/search/suggest?q=${keyword}&resources[type]=product&section_id=${sectionId}&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&resources[limit]=5`)
    .then(response => response.text())
    .then((responseText) => {
      if (callback) callback(responseText)
    })
    .catch((e) => {
      console.error(e)
    })
}